import { action, computed, observable, reaction, makeObservable } from 'mobx';
import { X5LessonSnapshot, X8BlockSnapshot } from '../../../domain';
import { Disposers, HttpPromiseState, logger } from '../../../lib/helpers';
import { Homework } from '../../homework/homework-models';
import { HomeworkUtils } from '../../homework/homework-utils';
import { HomeworkLoaders } from '../../homework/stores/homework-loaders';
import { ExamHubStore } from '../../exam/stores/ExamHubStore';

export class ExamStudentSceneStore {
  @observable.ref
  homeworkLoader: HttpPromiseState<Homework> | null;

  hubStore: ExamHubStore;

  @observable.ref
  snapshotState: HttpPromiseState<X5LessonSnapshot> | null;

  @observable.ref
  snapshot: X5LessonSnapshot | null;

  private readonly disposers = new Disposers();

  constructor(readonly examId: number) {
    makeObservable(this);
    this.homeworkLoader = null;

    this.hubStore = new ExamHubStore(examId, 'Student');
    this.disposers.add(this.hubStore);

    this.snapshotState = this.snapshot = null;
    this.setup();
  }

  private setup() {
    this.disposers.add(
      reaction(
        () => this.homeworkLoader?.value,
        this.onHomeworkLoaded),
      reaction(
        () => this.snapshotState?.value,
        this.onLessonLoaded),
     
    );
  }
 

  @action
  private onHomeworkLoaded = () => {
    const state = this.homeworkLoader;
    if (state === null || !state.isResolved)
      return;
    this.hubStore.start();
    this.loadLessonExam();
  };


  @action
  loadLessonExam = () => {
    if (this.snapshotState?.isPending)
      return;
    this.snapshotState = HomeworkLoaders.Student.getLessonExamSnapshot(this.examId);
  };

  @action
  loadExam = () => {
    if (this.homeworkLoader?.isPending)
      return;
    this.homeworkLoader = HomeworkLoaders.Student.getExam(this.examId);
  };

  @action
  private onLessonLoaded = () => {
    const state = this.snapshotState;
    if (state === null || !state.isResolved)
      return;
    this.snapshot = HomeworkUtils.prepareLesson(state.value);
  };
 

  dispose() {
    this.disposers.dispose();
  }
}
